module.exports = __webpack_public_path__ + "assets/img/teacher_top2.77953e6e.png";